import IconSvelte, { allIconNames, type IconName } from './Icon.svelte';

export type { IconName, IconProps } from './Icon.svelte';

type IconComponent = typeof IconSvelte;

interface IconExport extends IconComponent {
  availableIcons: IconName[];
}

export const Icon = IconSvelte as unknown as IconExport;
Icon.availableIcons = allIconNames;
